// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 714) return "714.37dc49399c5ec43a264d.css";
	// return url for filenames based on template
	return "" + "front" + "." + "b3f4d8c9cc61413088ac" + ".css";
};